import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { DisplayType } from 'entities/back-counter-tool';
import { Part } from 'entities/part';
import { CommonDataService } from 'services/common-data.service';
import { SourceLocationType } from 'services/logger.service';
import { AppState } from 'store/app-state';
import * as CartActions from 'store/cart/cart.actions';

@Component({
    selector: 'part-card-add-to-cart',
    templateUrl: './part-card-add-to-cart.component.html',
    styleUrls: ['./part-card-add-to-cart.component.scss'],
    standalone: false
})
export class PartCardAddToCartComponent {
  @Input() idSuffix: string = "";
  @Input() sourcePart: Part = null;
  @Input() part: Part;
  @Input() partType: SourceLocationType;
  @Input() displayType: DisplayType;
  @Output() addedToCart: EventEmitter<Part> = new EventEmitter();
  @Output() partAddedToRequest: EventEmitter<Part> = new EventEmitter();
  quantity = 1;

  constructor(
    private store: Store<AppState>,
    public commonDataService: CommonDataService
  ) { }

  addToCart(part: Part) {
    if (this.displayType === 'back-counter-tool') {
      // In back-counter-tool mode, emit to add to request instead of cart
      this.partAddedToRequest.emit({ ...part, quantity: this.quantity });
    } else {
      const trackingParameters = this.createTrackingParameters(part);

      this.store.dispatch(CartActions.addItemToCart({
        addCartItemRequest: {
          partId: part.partId,
          partNumber: part.rushPartNumber,
          binLocation: part.binLocation,
          quantity: this.quantity,
          trackingParameters: trackingParameters,
          coreOption: part.coreOption,
          adjustedPrice: part.adjustedPrice,
          description: part.description,
          quantityAvailable: part.quantityAvailable,
          sapCoupons: part.sapCoupons,
          isPriceVerified: part.isPriceVerified
        },
        sourceLocationType: this.partType
      }));
      this.addedToCart.emit({ ...part, quantity: this.quantity });
      const element = document.getElementById('headerSearch_text_SearchTerm');
      element.focus();
    }
  }

  createTrackingParameters(part: Part): string {
    switch (this.partType) {
      case SourceLocationType.FeaturedProduct: return this.getTrackingParametersForFeaturedProduct(part);
      case SourceLocationType.AlternateParts: return this.getTrackingParametersForAlternatePart(part);
      case SourceLocationType.RelatedParts: return this.getTrackingParametersForRelatedPart(part);
      default: return null;
    }
  }

  getTrackingParametersForFeaturedProduct(part: Part): string {
    const materialId = this.sourcePart?.rushPartNumber || part.rushPartNumber;
    return JSON.stringify({
      AddedFrom: "FeaturedProduct",
      PartId: part.partId,
      BranchCode: this.commonDataService.Branch.code,
      MaterialId: materialId
    });
  }

  getTrackingParametersForAlternatePart(part: Part): string {
    const groupPartId = this.sourcePart?.groupId || part.groupId;
    const materialId = this.sourcePart?.rushPartNumber || part.rushPartNumber;
    return JSON.stringify({
      AddedFrom: "AlternatePart",
      PartId: part.partId,
      GroupPartId: groupPartId,
      BranchCode: this.commonDataService.Branch.code,
      MaterialId: materialId
    });
  }

  getTrackingParametersForRelatedPart(part: Part): string {
    const groupRelatedPartId = this.sourcePart?.groupRelatedPartId || part.groupRelatedPartId;
    const materialId = this.sourcePart?.rushPartNumber || part.rushPartNumber;
    return JSON.stringify({
      AddedFrom: "RelatedPart",
      PartId: part.partId,
      GroupRelatedPartId: groupRelatedPartId,
      BranchCode: this.commonDataService.Branch.code,
      MaterialId: materialId
    });
  }

  changeQuantity(qty: number) {
    this.part.quantity = qty;
    this.quantity = qty;
  }
}
